// extracted by mini-css-extract-plugin
export default {"Header":"Header_Header__H4iSU","Header__Menu":"Header_Header__Menu__DXrdb","Header__LanguageSelector":"Header_Header__LanguageSelector__d4K-Z","spin":"Header_spin__RXatv"};